import React from 'react';
import type { LinkedTask } from '../../types/worklog';

// 「这次会话干了哪几条任务」。单条日志页与列表的右侧抽屉共用 —— 那两处是同一份
// 内容的两种读法，这一块长得一样，各写一份迟早会漂。
// 与任务那侧 Todo/LinkedWorklogs 是对称的一对。
//
// 没有关联时整块不渲染（由调用方判断 length），与任务那侧留空态刻意不对称：
// 一条日志写完就冻住了，没关联是常态不是缺失，给每条都留一句「暂无」等于在
// 几百个页面上重复一句废话。任务那侧相反 —— 任务是活的、会被推进。
// 见 docs/design/worklog-task-links-mockup.html 第 ④ 节。

type LinkedTasksProps = {
  tasks: LinkedTask[];
};

const LinkedTasks: React.FC<LinkedTasksProps> = ({ tasks }) => {
  if (tasks.length === 0) return null;

  return (
    <div className="mb-6">
      <div className="mb-2 flex items-baseline gap-2">
        <span className="text-sm font-semibold">这次干的任务</span>
        <span className="rounded-full border border-gray-200 px-1.5 py-px font-mono text-[11px] text-gray-500">
          {tasks.length}
        </span>
      </div>

      {tasks.map((task) => (
        <a
          key={task.id}
          href={`/todo/${task.url_key}`}
          className="mb-1.5 flex items-start gap-2.5 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 no-underline last:mb-0 hover:border-gray-300"
        >
          {/* 只读。画成勾选框是为了让「当时干的活后来完成了没有」一眼可见 ——
              一条日志最有回顾价值的就是这个。但在这里点不动它：日志是历史记录，
              在历史里改当下的状态是错的方向，要勾去任务那边勾。 */}
          <span
            aria-hidden
            className={`mt-0.5 flex h-3.5 w-3.5 flex-none items-center justify-center rounded border text-[10px] font-bold leading-none ${
              task.completed
                ? 'border-green-600 bg-green-600 text-white'
                : 'border-gray-300 bg-white'
            }`}
          >
            {task.completed ? '✓' : ''}
          </span>
          <span className="min-w-0 flex-1">
            <span
              className={`block text-[13px] leading-snug ${
                task.completed ? 'text-gray-400 line-through' : 'text-gray-900'
              }`}
            >
              {task.title}
            </span>
            {/* 两个标识都给：整数 id 是写 task_ids 时要用的，url_key 是点开链接
                用的。SKILL.md 专门警告过别把 url_key 当 id 传。 */}
            <span className="mt-0.5 block font-mono text-[10.5px] text-gray-400">
              #{task.id} · {task.url_key}
            </span>
          </span>
        </a>
      ))}
    </div>
  );
};

export default LinkedTasks;
